import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { LoggingService } from '../services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  loggingService = inject(LoggingService);
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.loggingService.log(error);
        return throwError(error);
      }),
    );
  }
}
